const regex = /^(\+*1\s?)?\(?\d{3}\)?-? *\d{3}-? *-?\d{4}$/i

const parsePhone = function(number) {
	let parsed = number.replaceAll('(', '').replaceAll(')', '').replaceAll('-', '').replaceAll(' ', '')
	if (number.substring(0, 2) != '+1') parsed = '+1' + parsed
	return parsed
}

export { regex, parsePhone }